import React from "react";
import styled from "styled-components";

export default function ProvisionTextInput(props) {
  const {
    value, 
    setValue, 
    placeholder
  } = props;

	function handleChange(e) {
    setValue(e.target.value);
	}

  return (
    <InputView>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={handleChange}/>
    </InputView>
  );
}

const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 10px 0px;

  width: calc(100% - 2px);
  height: calc(100% - 22px);

  border: 1px solid ${props => props.theme.line};
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const Input = styled.textarea`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

  padding: 0;

  width: calc(100% - 20px);
  height: 100%;

	outline: none;
  border: 0px;
	color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

  outline: none;
  resize: none;
  overflow-y: auto;

	::placeholder {
    color: ${props => props.theme.line};
	}

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.scrollBar};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.subBackground};
  }
	
  transition: all 0.3s ease-in-out;
`;